export const validateEmail = (email: string) => {
  const regex =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(email);
};

// The password doesn’t conform to security requirements

export const validatePassword = (password: string) => {
  const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,}$/;
  // /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%&*?])[A-Za-z\d#$@!%&*?]{8,322}$/;
  const passwordRegex = regex.test(password);
  return passwordRegex;
};

export const checkValidity = (password: any, email: any) => {
  const useremail = email.trim().toLowerCase();
  const userpassword = password.trim().toLowerCase();
  const threeParts = email.match(/.{3}/g) || [];
  const allThreeParts: any[] = threeParts.concat(
    useremail.slice(1).match(/.{3}/g) ?? [],
    useremail.slice(2).match(/.{3}/g) ?? []
  );
  return new RegExp(allThreeParts.join("|"), "i").test(userpassword);
};

// Unicode letters (incl. combining accents), spaces, hyphens, apostrophes and periods
const CITY_REGEX = /^[\p{L}\p{M}\s.'’-]+$/u;

const CITY_MAX_LENGTH = 80;

// Returns an error message, or an empty string when the city is valid.
// An empty value is valid because the field is optional.
export const validateCity = (city: string | null | undefined) => {
  const value = (city || "").trim();
  if (!value) {
    return city && city.length ? "City cannot contain only spaces" : "";
  }
  if (!CITY_REGEX.test(value)) {
    return "City can only contain letters, spaces, hyphens, apostrophes and periods";
  }
  if (value.length < 2) {
    return "City must be at least 2 characters";
  }
  if (value.length > CITY_MAX_LENGTH) {
    return `City must be no more than ${CITY_MAX_LENGTH} characters`;
  }
  return "";
};
